/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * GroupElement.web.tsx - A single counter for the GroupArray
 */

import './Group.web.css';


interface GroupElementProps {
  color: string;
}

const GroupElement = ({ color }: GroupElementProps) => {
  if (color !== 'clear') {
    return (
      <div className="square">
        <div className="circle"  />
      </div>
    );
  }

  return (
    <div className="square" />
  );
};

export default GroupElement;
